export default [{
    path: "/app/request",
    name: "request",
    redirect: {
        name: 'dashboard'
    },
    component: () => import("../../../views/dashboard/customer/RequestsComponent.vue"),
    children: [{
            path: "/app/request/deposit",
            name: "requests.deposit",
            component: () => import("../../../views/dashboard/customer/requests/DepositComponent.vue"),
            meta: {
                allowedUsers: ['customer']
            }
        },
        {
            path: "/app/request/withdraw",
            name: "requests.withdraw",
            component: () => import("../../../views/dashboard/customer/requests/WithdrawComponent.vue"),
            meta: {
                allowedUsers: ['customer']
            }
        },
        {
            path: "/app/request/statement",
            name: "requests.statement",
            component: () => import("../../../views/dashboard/customer/requests/StatementComponent.vue"),
            meta: {
                allowedUsers: ['customer']
            }
        }
    ]
}]
